import { render, staticRenderFns } from "./report-school.vue?vue&type=template&id=eb758364&scoped=true&"
import script from "./report-school.vue?vue&type=script&lang=js&"
export * from "./report-school.vue?vue&type=script&lang=js&"
import style0 from "./report-school.vue?vue&type=style&index=0&id=eb758364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb758364",
  null
  
)

export default component.exports